import { $isstring, $length, $ok } from "foundation-ts/commons";
import { $trim } from "foundation-ts/strings";
// import { $absolute, $loadJSON } from "foundation-ts/fs";
import { language, Languages, Nullable, StringTranslation, TSDictionary } from "foundation-ts/types";

let LOCAL_LANGUAGE: language = Languages.fr;
export type LocalTranslations = TSDictionary<StringTranslation>;

let LOCAL_TRANSLATIONS: LocalTranslations = {
    "currentMonthConsumptions": {
        "fr": "Consommation du mois en cours",
        "en": "Current month consumption"
    },
    "currentQSCDConsumptions": {
        "fr": "Nombre de signatures en QSCD",
        "en": "QSCD signatures"
    },
    "currentOTPConsumptions": {
        "fr": "Nombre de signatures simples",
        "en": "OTP signatures"
    },
    "QSCDConsumptions": {
        "fr": "NB signatures QSCD",
        "en": "QSCD signatures"
    },
    "OTPConsumptions": {
        "fr": "Nb signatures simples",
        "en": "OTP signatures"
    },
    "addSignerBoxTitle": {
        "fr": "Ajouter un signataire ?",
        "en": "Add a signer?"
    },
    "addSignerBoxQSCD": {
        "fr": "Identité qualifiée",
        "en": "QSCD"
    },
    "addSignerBoxStandardAction": {
        "fr": "Simple",
        "en": "OTP"
    },
    "cancel": {
        "fr": "Annuler",
        "en": "Cancel"
    },
    "delete": {
        "fr": "Supprimer",
        "en": "Delete"
    },
    "download": {
        "fr": "Télécharger",
        "en": "Download"
    },
    "sign": {
        "fr": "Signer",
        "en": "Sign"
    },
    "approve": {
        "fr": "Approuver",
        "en": "Approve"
    },
    "refuse": {
        "fr": "Refuser",
        "en": "Refuse"
    },
    "back": {
        "fr": "Retour",
        "en": "Back"
    },
    "confirm": {
        "fr": "Confirmer",
        "en": "Confirm"
    },
    "OTPSignature": {
        "fr": "signature simple",
        "en": "OTP signature"
    },
    "QSCDSignature": {
        "fr": "Signature qualifiée",
        "en": "Qualified signature"
    },
    "OTPSignatureOption": {
        "fr": "soit une signature simple qui est validée par l'envoi d'un code par courrier électronique",
        "en": "either a standard signature validated by a One Time Password by email"
    },
    "QSCDSignatureOption": {
        "fr": "soit une signature avancée avec une identité qualifiée validée par un dispositif de sécurité ou une carte dédiée.",
        "en": "or an advanced signature with a qualified identity supported by a personal card or a system including a QSCD token."
    },
    "OTPSignerForcedPosition": {
        "fr": "Cette personne a été choisie pour signer en signature simple, elle doit donc être placée en première position.",
        "en": "This signer is maint to sign with a One Time Password. He or she must be the first to sign."
    },
    "QSCDSignerForcedPosition": {
        "fr": "Cette personne a été choisie pour signer en signature avancée avec identité qualifiée, elle doit donc être placée en dernière position.",
        "en": "This signer is maint maint to make an advanced signature with a qualified identity. He or she must be the last to sign."
    },
    "NewSessionView.NextSignerQSCDModeMessage": {
        "fr": "Le signataire précédent a été choisi pour signer en signature avancée avec une identité qualifiée, les signataires suivants ne peuvent donc être également qu'en signature avancée avec identité qualifiée.",
        "en": "Previous signer is maint to sign with a qualified signature, so subsequent signers can only be done with a qualified signature as well."
    },
    "NewSessionView.ToggleSignatureVisibilitySwitchMessage": {
        "fr": "Vous avez défini des signataires en mode simple. Ce mode n'est pas accepté si vous ne souhaitez pas afficher les signatures dans le document. Vous avez donc la possibilté soit de les convertir en mode signature avancée avec identité qualifiée, soit de les supprimer de la liste des signataires. Que souhaitez-vous faire ?",
        "en": "You have defined signers in simple mode. This mode is not accepted if you do not want to display the signatures in the document. You therefore have the option of either converting them to advanced mode with qualified identity or removing them from the list of signers. What do you want to do?"
    },
    "NewSessionView.ToggleOneToManySwitchMessage": {
        "fr": "Les signataires à partir de $firstSigner qui sont définis en mode simple doivent être convertis en mode signature avancée avec une identité qualifiée. Vous avez donc la possibilté soit de les convertir, soit de les supprimer de la liste des signataires. Que souhaitez-vous faire ?",
        "en": "From $firstSigner onward, signers in simple mode must be converted to advanced signature mode with a qualified identity. You can either convert them or remove them from the list. What would you like to do?"
    },
    "WaitingForCertificatesList": {
        "fr": "Récupération des certificats en cours ...",
        "en": "Listing certificates on connected devices..."
    },
    "SigningDeviceNotConnected": {
        "fr": "Impossible de se connecter au système de signature.",
        "en": "No signing device connected."
    },
    "CertificatesNotFound": {
        "fr": "Votre dispositif de signature ne comporte pas de certificats.",
        "en": "Impossible to find any certificate on your connected devices."
    },
    "CancellingCurrentSession": {
        "fr": "Annulation de la session en cours.",
        "en": "Cancelling current session."
    },
    "SessionWasCancelled": {
        "fr": "Annulation de la session prise en compte.",
        "en": "Session cancellation was done."
    },
    "SessionCouldNotBeCancelled": {
        "fr": "L'annulation de la session n'a pas pu aboutir",
        "en": "Session cancellation could not be done"
    },
    "SessionMinimalDurationError":{
        "fr": "La session doit avoir une durée minimale de $days jours.",
        "en": "Session must last at lease $days days."
    },
    "WaitingForLocalSignature": {
        "fr": "Signature avec votre dispositif ...",
        "en": "Waiting for signature with your connected device..."
    },
    "WaitingForSignatureRefused": {
        "fr": "Refus de signature en cours ...",
        "en": "Waiting for refusing signature..."
    },
    "LocalSignatureWasDone": {
        "fr": "Opération de signature effectuée.",
        "en": "Signature with your connected device is done."
    },
    "LocalSignatureWasCancelled": {
        "fr": "Opération de signature annulée.",
        "en": "Signature operation was cancelled."
    },
    "DocumentsViewer.SignatureWasRefused": {
        "fr": "Refus de signature pris en compte.",
        "en": "Signature was refused."
    },
    "DocumentsViewer.SignatureCouldNotBeRefused": {
        "fr": "Le refus de signature n'a pas pu aboutir.",
        "en": "Signature could not be refused. Operation was cancelled."
    },
    "ImpossibleToDownloadDocuments": {
        "fr": "Impossible de télécharger les documents.",
        "en": "Impossible to download documents."
    },
    "DownloadDocumentError": {
        "fr": "Erreur lors du téléchargement du document",
        "en": "Did encounter an error during download of document"
    },
    "SignatureFileTitle": {
        "fr": "Dossier de signature",
        "en": "Signature file"
    },
    "SignatureTitleField": {
        "fr": "Titre de la signature",
        "en": "Signature title"
    },
    "SignatureTitleFieldPlaceholder": {
        "fr": "Nouvelle session",
        "en": "New session"
    },
    "SignatureObjectField": {
        "fr": "Objet de la signature",
        "en": "Signature object"
    },
    "SignatureObjectPlaceholder": {
        "fr": "Description optionnelle",
        "en": "Optional signature description"
    },
    "SignatureCalendarField": {
        "fr": "À signer avant le",
        "en": "To be signed before"
    },
    "SignatureDaysField": {
        "fr": "Nombre de jours de validité",
        "en": "Validity days"
    },
    "SignatureInvisibilitySwitch": {
        "fr": "Ne pas afficher les signatures",
        "en": "Don't show signatures"
    },
    "SignatureExpeditorSection": {
        "fr": "Expéditeur",
        "en": "Expeditor"
    },
    "SignatureSignersSection": {
        "fr": "Signataires",
        "en": "Signers"
    },
    "SignatureDocumentsSection": {
        "fr": "Documents à signer",
        "en": "Documents to be signed"
    },
    "AddSignerButton": {
        "fr": "Ajouter un signataire",
        "en": "Add a new signer"
    },
    "SignatureBox.DefaultSignersDescription": {
        "fr": "jusqu'à $max signataires",
        "en": "up to $max signers"
    },
    "NewSessionView.SignersLimitReached": {
        "fr": "Vous avez atteint la limite des $max signataires, veuillez-en supprimer avant d'en sélectionner de nouveaux",
        "en": "You have reached the limit of $max signers, please remove some before selecting new ones"
    },
    "NewSessionView.MissingPlacedSigners": {
        "fr": "Vous ne pouvez pas mettre en signature cette session, parce que vous n'avez pas positionné l'ensemble des signataires sur l'ensemble des documents",
        "en": "You cannot sign this session because not all signers have been positioned on all documents"
    },
    "SignatureBox.AddApproverButton": {
        "fr": "Ajouter un approbateur",
        "en": "Add a new approver"
    },
    "SignatureBox.ApproversSection": {
        "fr": "Approbateurs",
        "en": "Approvers"
    },
    "SignatureBox.ApprovalOption": {
        "fr": "Ajouter des approbateurs",
        "en": "Add approvers"
    },
    "SignatureBox.DefaultApproversDescription": {
        "fr": "jusqu'à $max approbateurs",
        "en": "up to $max approvers"
    },
    "SignatureBox.OneToManyOption": {
        "fr": "Signature solo",
        "en": "Standalone signature"
    },
    "SignatureBox.AddApproverDescription": {
        "fr": "Cette option vous permet de définir une liste de personnes qui doivent valider, les unes après les autres, les différents éléments composant une session de signature (signataires / documents), et ceci avant de permettre aux signataires de signer.",
        "en": "This option allows you to define a list of people who must validate, one after the other, the various elements of a signing session (signers/documents), before allowing the signers to sign."
    },
    "SignatureBox.OneToManyModeDescription": {
        "fr": "Cette option vous permet de définir plusieurs signataires pour 1 document mais 1 signataire sur chaque document. Donc, pour 10 signataires et 1 document = 10 documents signés unitairement.",
        "en": "This option allows you to define multiple signers for one document, but only one signer per document. Therefore, for 10 signers and one document, you will have 10 individually signed documents."
    },
    "NewSessionView.PleaseSelectAtLeastOneApprover": {
        "fr": "Veuillez sélectionner au moins un approbateur ou désactiver l'option 'Ajouter des approbateurs'",
        "en": "Please select at least one approver or deactivate 'Add approvers' option"
    },
    "NewSessionView.ApproversLimitReached": {
        "fr": "Vous avez atteint la limite des $max approbateurs, veuillez-en supprimer avant d'en sélectionner de nouveaux",
        "en": "You have reached the limit of $max approvers, please remove some before selecting new ones"
    },
    "NewSessionView.LoadingEncryptedPDF": {
        "fr": "Le document PDF est chiffré - Il ne peut pas être signé",
        "en": "The PDF document is encrypted - It cannot be signed"
    },
    "NewSessionView.LoadingReadonlyPDF": {
        "fr": "Le document PDF est protégé en écriture - Il ne peut pas être signé",
        "en": "The PDF document is write-protected - It cannot be signed"
    },
    "NewSessionView.LoadingFailedPDF": {
        "fr": "Une erreur s'est produite lors du chargement du document PDF",
        "en": "An error occurred while loading the PDF document."
    },
    "DocumentsViewer.ApprovalConfirmationModalTitle": {
        "fr": "Confirmation d'approbation",
        "en": "Approval confirmation"
    },
    "DocumentsViewer.ApprovalConfirmationModalDesc": {
        "fr": "En cliquant sur approuver, vous validez, pour cette session de signature, l'ensemble des approbateurs, des signataires et des documents présentés ci-dessous. Voulez-vous continuer ?",
        "en": "By clicking on approve, you validate, for this signing session, all the approvers, signers and documents presented below. Do you wish to continue ?"
    },
    "DocumentsViewer.ApprovalButton": {
        "fr": "Approuver",
        "en": "Approve"
    },
    "DocumentsViewer.NextApprovalAction": {
        "fr": "Le prochain approbateur vient d'être notifié",
        "en": "The next approver has just been notified"
    },
    "DocumentsViewer.ProcessSignatureAction": {
        "fr": "Vous êtes le dernier approbateur de la session, le premier signataire vient donc d'être notifié",
        "en": "You are the last approver of the session, so the first signer has just been notified"
    },
    "DocumentsViewer.SucceededApproveSession": {
        "fr": "Cette session de signature a été approuvée. $nextAction.",
        "en": "This signing session has been successfully approved. $nextAction."
    },
    "DocumentsViewer.FailedApproveSession": {
        "fr": "Une erreur est intervenue lors de l'approbation de cette session de signature",
        "en": "An error occurred while approving this signing session"
    },
    "DocumentsViewer.RefusalConfirmationTitle": {
        "fr": "Refus $type",
        "en": "$type Refusal"
    },
    "DocumentsViewer.RefusalSigningType": {
        "fr": "de signature",
        "en": "Signing"
    },
    "DocumentsViewer.RefusalApprovalType": {
        "fr": "d'approbation",
        "en": "Approval"
    },
    "DocumentsViewer.RefusalSigningDescription": {
        "fr": "Êtes-vous bien sûr d'avoir pris connaissance des documents à signer et de refuser de les signer ?",
        "en": "Are you sure you have read the documents to be signed and refuse to sign them ?"
    },
    "DocumentsViewer.RefusalApprovalDescription": {
        "fr": "Êtes-vous bien sûr d'avoir pris connaissance des différents éléments composant la session de signature et de refuser d'approuver ?",
        "en": "Are you sure you have read the various elements that make up the signing session and refuse to approve ?"
    },
    "DocumentsViewer.WaitingApproval": {
        "fr": "Approbation en cours...",
        "en": "Waiting approval..."
    },
    "DocumentsViewer.ApprovalWasRefused": {
        "fr": "Refus d'approbation pris en compte.",
        "en": "Approval was refused."
    },
    "DocumentsViewer.ApprovalCouldNotBeRefused": {
        "fr": "Le refus d'approbation n'a pas pu aboutir.",
        "en": "Approval could not be refused. Operation was cancelled."
    },
    "DocumentsViewer.RefusalSigningModalTitle": {
        "fr": "Refus de signer",
        "en": "Signing refusal"
    },
    "DocumentsViewer.RefusalApprovalModalTitle": {
        "fr": "Refus d'approuver",
        "en": "Approval refusal"
    },
    "DocumentsViewer.EndSessionDateLabel": {
        "fr": "Fin de session le $end",
        "en": "Session ends at $end"
    },
    "DocumentsViewer.EndSessionDateBeforeLabel": {
        "fr": "Fin de session avant le $end",
        "en": "Session end before $end"
    },
    "DocumentsViewer.EditEndSessionButtonTitle": {
        "fr": "Changer la date de fin de session",
        "en": "Update end session date"
    },
    "DocumentsViewer.ValidateChangedEndSessionDateButtonTitle": {
        "fr": "Confirmer le changement de date de fin de session",
        "en": "Confirm the change of session end date"
    },
    "DocumentsViewer.CancelChangedEndSessionDateButtonTitle": {
        "fr": "Annuler le changement de date de fin de session",
        "en": "Cancel the change of session end date"
    },
    "SignatureModal.ChoiceSignatureType": {
        "fr": "Choix du mode de signature",
        "en": "Choice of signature type"
    },
    "SignatureModal.UsedEmailOTP": {
        "fr": "Signature OTP",
        "en": "OTP signature"
    },
    "SignatureModal.UsedEmailOTPDesc": {
        "fr": "Recevez un code de vérification par email",
        "en": "Get a verification code by email"
    },
    "SignatureModal.UsedQualifiedType": {
        "fr": "Signature Qualifiée",
        "en": "Qualified signature"
    },
    "SignatureModal.UsedQualifiedTypeDesc": {
        "fr": "Utilisez votre identité qualifiée",
        "en": "Use your qualified identity"
    },
    "SignatureModal.ConfirmEmail": {
        "fr": "Confirmation de votre adresse mail",
        "en": "Confirm your email"
    },
    "SignatureModal.ConfirmEmailDesc": {
        "fr": "Un code de vérification sera envoyé à cette adresse.",
        "en": "A verification code will be sent to this email."
    },
    "SignatureModal.ConfirmOTP": {
        "fr": "Saisie du code OTP",
        "en": "Confirm OTP code"
    },
    "SignatureModal.SentCode": {
        "fr": "Un code à 6 chiffres a été envoyé à",
        "en": " A 6-digit code has been sent to"
    },
    "SignatureModal.NotReceivedOTP": {
        "fr": "Vous n'avez pas reçu le code ? ",
        "en": "Didn't receive the code? "
    },
    "SignatureModal.ResendOTP": {
        "fr": "Renvoyer le code",
        "en": "Resend the code"
    },
    "SignatureModal.VerifyingOTPStep": {
        "fr": "Vérification OTP en cours",
        "en": "Verifying OTP code",
    },
    "SignatureModal.SigningDocStep": {
        "fr": "Signature en cours",
        "en": "Signing in progress"
    },
    "SignaturesManager.DropFirst": {
        "fr": "Déplacer ici pour être le premier signataire",
        "en": "Drag here to become the first signer"
    },
    "SignaturesManager.DropBetween": {
        "fr": "Déplacer ici pour être seul",
        "en": "Drag here to be alone"
    },
    "SignaturesManager.DropLast": {
        "fr": "Déplacer ici pour être le dernier signataire",
        "en": "Drag here to become the last signer"
    }
};

export function setLocalTranslationLanguage(l?: Nullable<language>) {
    LOCAL_LANGUAGE = $length(l) ? l! : Languages.fr;
}

export function localtrans(s: string, l?: Nullable<language>): string {
    if (!s.length) { return ''; }
    let st = $trim(s); if (!st.length) { return ''; }
    const node = LOCAL_TRANSLATIONS[st]; if (!$ok(node)) { return s ; }
    if (!$length(l)) { l = LOCAL_LANGUAGE; }
    let t = node![l!];
    if (!$length(t) && l !== Languages.en) { t = node[Languages.en]; }
    if (!$length(t) && l !== Languages.fr) { t = node[Languages.fr]; }
    return $length(t) ? t! : s;
}

export function localformat(format: string, variables: Record<string, any>, l?: Nullable<language>): string {
    format = localtrans(format, l);
    return format.replace(/\$(\w+)/g, (match, variableName) => {
        if (variableName in variables) {
            const v = variables[variableName] ;
            return $isstring(v) ? localtrans(v, l) : variables[variableName]?.toString() ?? '' ;
        }
        return '';
    });
}
